import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ filter, sort, size, index, view }) =>
    present(
      repository
        .getZonesIndicators(filter, sort, view || "simple", size, index)
        .then((zones) => ({ filter, sort, size, index, zones, view }))
        .catch((e) => Promise.reject({ filter, sort, size, index, view })),
    );
}

export type { Interactor };

export { createInteractor };
